<script lang="ts" setup>
const route = useRoute()

if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })
</script>

<template>
  <CompaniesDirectory :route-key="route.params?.key.toString()" />
</template>
